import React from "react";

export const fixedHTML = (html) => {
   if (html?.value) {
      return html.value;
   }
   if (typeof html !== "string" && typeof html !== "number") return "";
   if (html && html?.toString()?.includes("<"))
      return (
         <span style={{ wordBreak: "break-word" }} dangerouslySetInnerHTML={{ __html: html }} />
      );
   else return html;
};
